import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SearchBox from '../components/SearchBox';
import Button from 'react-bootstrap/Button';
import {
  AssignGridFilterType,
  ColXsMdType,
  LocationFilterType,
} from '../utils/Types';
import LocationFilter from './LocationFilter';
import {
  assignGridRoleOption,
  assignGridStatusOption,
  DEFAULT_OPTION_LOCATION,
} from '../utils/Constant';
import SelectBox from '../components/SelectBox';

interface IAssignGridFilterProps {
  onApplyFilters: (assignGridFilter: AssignGridFilterType) => void;
}

const colSize: ColXsMdType = {
  xs: 6,
  md: 3,
};

const defaultFilter: AssignGridFilterType = {
  employeeId: '',
  employeeName: '',
  roleId: DEFAULT_OPTION_LOCATION,
  assignStatus: DEFAULT_OPTION_LOCATION,
  zone: DEFAULT_OPTION_LOCATION,
  state: DEFAULT_OPTION_LOCATION,
  district: DEFAULT_OPTION_LOCATION,
  city: DEFAULT_OPTION_LOCATION,
};

function AssignGridFilter({
  onApplyFilters,
}: Readonly<IAssignGridFilterProps>) {
  const [assignGridFilter, setAssignGridFilter] =
    useState<AssignGridFilterType>(defaultFilter);
  return (
    <div className="border rounded  ps-3 pt-2 pb-3 pe-3">
      <Row>
        <Col xs={6} md={3}>
          <SearchBox
            label="Search by Emp. Id"
            placeHolder="Ex. 1001001"
            value={assignGridFilter.employeeId}
            onChange={(e: any) => {
              setAssignGridFilter({
                ...assignGridFilter,
                employeeId: e.target.value,
              });
            }}
          />
        </Col>
        <Col xs={6} md={4}>
          <SearchBox
            label="Search by Emp. Name"
            placeHolder="Ex. John Doe"
            value={assignGridFilter.employeeName}
            onChange={(e: any) => {
              setAssignGridFilter({
                ...assignGridFilter,
                employeeName: e.target.value,
              });
            }}
          />
        </Col>
        <Col xs={6} md={2}>
          <SelectBox
            label="Filter By Role"
            options={assignGridRoleOption}
            className="css-select-bg"
            value={assignGridFilter.roleId ?? ''}
            onChange={(event: any) => {
              setAssignGridFilter({
                ...assignGridFilter,
                roleId: event,
              });
            }}
          />
        </Col>
        <Col xs={6} md={3}>
          <SelectBox
            label="Filter By Grid Assign Status"
            options={assignGridStatusOption}
            className="css-select-bg"
            value={assignGridFilter.assignStatus ?? ''}
            onChange={(event: any) => {
              setAssignGridFilter({
                ...assignGridFilter,
                assignStatus: event,
              });
            }}
          />
        </Col>
      </Row>

      <LocationFilter
        size={{
          zone: colSize,
          state: colSize,
          district: colSize,
          city: colSize,
        }}
        filterData={{
          zone: assignGridFilter.zone,
          state: assignGridFilter.state,
          district: assignGridFilter.district,
          city: assignGridFilter.city,
        }}
        setLocationFilter={(filter: LocationFilterType) => {
          setAssignGridFilter({
            ...assignGridFilter,
            zone: filter.zone,
            state: filter.state,
            district: filter.district,
            city: filter.city,
          });
        }}
      />

      <Row>
        <Col
          xs={12}
          md={4}
          className="d-flex align-items-center pt-1 filter-button-parent"
        >
          <Button
            variant="primary"
            className="cl-btn-primary"
            onClick={() => {
              onApplyFilters(assignGridFilter);
            }}
          >
            Search
          </Button>
          <Button
            variant="outline-primary"
            className="mx-2 cl-btn-outline-primary"
            onClick={() => {
              setAssignGridFilter(defaultFilter);
              onApplyFilters(defaultFilter);
            }}
          >
            Reset
          </Button>
        </Col>
      </Row>
    </div>
  );
}

export default AssignGridFilter;
